import { loadStripe, type Stripe } from '@stripe/stripe-js';

const stripeInstanceCache: Record<string, Promise<Stripe | null>> = {};

export function getStripeInstance(stripeAccountId?: string | null): Promise<Stripe | null> {
  const publishableKey = (import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY as string | undefined) ?? '';
  if (!publishableKey) {
    return Promise.resolve(null);
  }

  const cacheKey = `${publishableKey}:${stripeAccountId || 'platform'}`;
  if (!Object.prototype.hasOwnProperty.call(stripeInstanceCache, cacheKey)) {
    stripeInstanceCache[cacheKey] = loadStripe(
      publishableKey,
      stripeAccountId ? { stripeAccount: stripeAccountId } : undefined,
    );
  }
  return stripeInstanceCache[cacheKey];
}
